import { Select } from "antd";
import { Field, Form, useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchFieldData } from "@/reducers/clientcommon";

import Button from "../Button";
import Label from "../forms/Label";
import { SelectDownIcon } from "../Icons/SelectDownIcon";

const CandidatePaymentForm = ({ id }) => {
  const dispatch = useDispatch();
  const { values, submitForm, setValues, errors, isSubmitting } =
    useFormikContext();
  const candidateDropdownData =
    useSelector((state) => state.clientCommon.candidateDropdownData) || {};
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [umbrellaCompanyList, setUmbrellaCompanyList] = useState([]);
  useEffect(() => {
    if (candidateDropdownData.payment_methods) {
      setPaymentMethods(
        Object.entries(candidateDropdownData.payment_methods).map(
          ([key, value]) => ({
            id: key,
            name: value,
          }),
        ),
      );
    }
  }, [candidateDropdownData]);

  useEffect(() => {
    const callback = (data) => {
      setUmbrellaCompanyList(data || []);
    };
    dispatch(
      fetchFieldData({
        field_type: "all_umbrella_company",
        candidateId: id,
        callback,
      }),
    );
  }, []);
  return (
    <Form>
      <div className="grid gap-4">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3">
          <div className="grid gap-3">
            <Label htmlFor="paymentMethod" isRequired={true}>
              Payment Method
            </Label>
            <Select
              name="paymentMethod"
              placeholder="Select Payment Method"
              suffixIcon={<SelectDownIcon cls={"text-txtColor"} />}
              value={values.paymentMethod}
              onChange={(val) =>
                setValues({
                  ...values,
                  paymentMethod: val,
                })
              }
            >
              {paymentMethods.map((method) => (
                <Select.Option key={method.id} value={method.id}>
                  {method.name}
                </Select.Option>
              ))}
            </Select>
          </div>
          {/* {
            values.paymentMethod === "Limited" && (
                <>
                
                </>
            )
          } */}
          {values.paymentMethod === "Umbrella" && (
            <>
              <div className="grid gap-3">
                <Label htmlFor="umbrellaCompany" isRequired={false}>
                  Umbrella Company
                </Label>
                <Select
                  name="umbrellaCompany"
                  placeholder="Select Umbrella Company"
                  suffixIcon={<SelectDownIcon cls={"text-txtColor"} />}
                  value={values.umbrellaCompany}
                  onChange={(val) =>
                    setValues({ ...values, umbrellaCompany: val })
                  }
                >
                  {umbrellaCompanyList.map((company) => (
                    <Select.Option key={company.id} value={company.id}>
                      {company.name}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            </>
          )}
          <div className="grid gap-3">
            <Label
              htmlFor="bdAccountName"
              isRequired={
                values.paymentMethod === "Limited" ||
                values.paymentMethod === "Self Employed"
              }
            >
              Name on Bank Account
            </Label>
            <Field
              name="bdAccountName"
              placeholder="Enter Account Name"
              type="text"
            />
          </div>
          <div className="grid gap-3">
            <Label
              htmlFor="bdAccountNo"
              isRequired={
                values.paymentMethod === "Limited" ||
                values.paymentMethod === "Self Employed"
              }
            >
              Account Number
            </Label>
            <Field
              name="bdAccountNo"
              placeholder="Enter Account Number"
              type="text"
            />
          </div>
          <div className="grid gap-3">
            <Label
              htmlFor="bdSortCode"
              isRequired={
                values.paymentMethod === "Limited" ||
                values.paymentMethod === "Self Employed"
              }
            >
              Sort Code
            </Label>
            <Field
              name="bdSortCode"
              placeholder="Enter Sort Code"
              type="text"
            />
          </div>
        </div>
        <div>
          <Button
            type="button"
            className={`transition-linear relative h-[40px] w-[120px] rounded-lg border border-primary bg-primary text-[14px] font-medium text-white hover:bg-none hover:text-primary ${isSubmitting ? "cursor-wait" : "cursor-pointer"}`}
            onClick={() => {
              if (isSubmitting) return;
              submitForm();
            }}
            disabled={isSubmitting}
          >
            Submit
          </Button>
        </div>
      </div>
    </Form>
  );
};

export default CandidatePaymentForm;
